module.exports = __webpack_public_path__ + "static/media/close-circle.cdf49a3c.svg";